import { api } from "@/lib/api";

const KEY = "neeyosi_visitor_id";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  // fallback
  return "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getVisitorId() {
  if (typeof window === "undefined") return "";
  let v = localStorage.getItem(KEY);
  if (!v) {
    v = uuid();
    localStorage.setItem(KEY, v);
  }
  return v;
}

export function trackHit(path, lang) {
  try {
    const visitor_id = getVisitorId();
    if (!visitor_id) return;
    api
      .post(
        "/hit",
        {
          visitor_id,
          path,
          lang,
          ref: document.referrer || "",
        },
        { timeout: 4000 }
      )
      .catch(() => {});
  } catch {
    /* no-op */
  }
}
